import { useContext } from 'react'

import { SelectedAppContext } from './'

export const useSelectedApp = () => {
	const selectedApp = useContext(SelectedAppContext)

	return selectedApp
}
